export const screenConfig = async () => {
  const configFile = "/config.json";
  let conf;
  try {
    console.groupCollapsed("Config file");
    console.log("Config file path: ", configFile);
    const response = await fetch(configFile);
    conf = await response.json();
    console.groupEnd();
  } catch (e) {
    throw Error(`Config: unable to find '${configFile}' file`);
  }
  if (!conf) throw Error("Config is empty");
  return conf;
};
